module.exports = __webpack_public_path__ + "static/img/zhly01.38b2423.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zhly01.png
// module id = 6G03
// module chunks = 1